import React, { useState, useEffect } from 'react';
import { ROUTES } from '@solarwindscloud/sso-nighthawk-shared';
import { WithBackendConfig } from '../../providers/BackendConfigProvider/BackendConfigProvider';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Header, Grid } from '@solarwindscloud/nighthawk-ui';
import fetchUser from '../../api/actions/fetchUser/fetchUser';
import { redirectTo } from '../../utils/utils';
import { UserInitials } from '../../components';
import { ActionButton } from './components/ActionButton';
import styles from './LoginOrSignUp.module.scss';
import { get } from 'lodash';

export const dataTestIds = {
  loginOrSignUp: 'login-or-sign-up',
  linkToLogin: 'product-continue', // keep old names for tasman support
  linkToSignup: 'product-sign-in',
  email: 'email',
};

const isEmailTooLong = email => email?.length > 32;
const truncateEmail = email => {
  return isEmailTooLong(email) ? email.slice(0, 30) + '...' : email;
};

const LoginOrSignUp = ({ backendConfig }) => {
  const [user, setUser] = useState({ firstName: '', surname: '', email: '' });
  const [signupLink, setSignupLink] = useState('');

  useEffect(() => {
    const asyncLoadUser = async () => {
      try {
        const currentUser = await fetchUser();
        const { first_name: firstName, last_name: surname, email } = currentUser;
        setUser({
          firstName,
          surname,
          email,
        });

        const signupLink = await get(backendConfig, 'signUpLink.nighthawk');
        setSignupLink(signupLink);
      } catch (e) {
        redirectTo(ROUTES.ERROR);
      }
    };

    asyncLoadUser();
  }, [backendConfig]);

  const isEverythingLoaded = user && user.email;
  const tooltipEmail = isEmailTooLong(user.email) ? user.email : '';

  if (!isEverythingLoaded) {
    return <span>Loading...</span>;
  }

  return (
    <UnifiedLayout dataTestId={dataTestIds.loginOrSignUp} dataTestPageName="LoginOrSignUp">
      <Grid centered>
        <Grid.Row>
          <UserInitials firstName={user.firstName} surname={user.surname} email={user.email} />
          <Header textAlign="center">
            <Header.Subheader>
              We noticed that you are currently logged in <br />
              as{' '}
              <span className={styles.email} data-test-id={dataTestIds.email} title={tooltipEmail}>
                {truncateEmail(user.email)}
              </span>
              <br />
              How would you like to continue?
            </Header.Subheader>
          </Header>
        </Grid.Row>
        <Grid.Row>
          <ActionButton
            testTag={dataTestIds.linkToLogin}
            url={ROUTES.LOGIN}
            mainText={`Continue to Login`}
            descriptionText="Stay logged in without creating a new account."
          />
        </Grid.Row>
        <Grid.Row>
          <ActionButton
            testTag={dataTestIds.linkToSignup}
            url={`${ROUTES.LOGOUT}?redirect_uri=${signupLink}`}
            mainText={`Continue to the Sign up form`}
            descriptionText="Log out from current session and create a new account."
          />
        </Grid.Row>
      </Grid>
    </UnifiedLayout>
  );
};

export { LoginOrSignUp };
export default WithBackendConfig(LoginOrSignUp);
